import isNaN from 'lodash/isNaN';

const isNumericId = (id) => isNaN(parseInt(id, 10));

export default isNumericId;
